export default {
  'Extract audio': '오디오 추출',
  'Mute': '음소거',
  'Split video and audio': '비디오와 오디오 분할',
}